export const IconSearch = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.7291 12.4362C10.5923 13.4111 9.11494 14 7.5 14C3.91015 14 1 11.0899 1 7.5C1 3.91015 3.91015 1 7.5 1C11.0899 1 14 3.91015 14 7.5C14 9.11495 13.411 10.5924 12.4362 11.7291L15.8536 15.1465C16.0488 15.3417 16.0488 15.6583 15.8536 15.8536C15.6583 16.0489 15.3417 16.0489 15.1465 15.8536L11.7291 12.4362ZM13 7.5C13 10.5376 10.5376 13 7.5 13C4.46243 13 2 10.5376 2 7.5C2 4.46243 4.46243 2 7.5 2C10.5376 2 13 4.46243 13 7.5Z"
    />
  </svg>
);
